import React from 'react';

const BetLive = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.66406 6.6682C1.66406 5.28716 2.78362 4.1676 4.16467 4.1676H10.8329C12.214 4.1676 13.3335 5.28716 13.3335 6.66821V13.3365C13.3335 14.7175 12.214 15.8371 10.8329 15.8371H4.16466C2.78362 15.8371 1.66406 14.7175 1.66406 13.3365V6.6682Z",
      stroke: "white",
      strokeWidth: "1.2503"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3359 8.33527L16.97 5.30689C17.5129 4.85447 18.3371 5.24053 18.3371 5.94723V14.0575C18.3371 14.7642 17.5129 15.1502 16.97 14.6978L13.3359 11.6694V8.33527Z",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.25 7.91846L9.58414 10.0023L6.25 12.0861V7.91846Z",
      fill: "white",
      stroke: "white",
      strokeWidth: "1.2503",
      strokeLinejoin: "round"
    }
  )
);

export { BetLive };
//# sourceMappingURL=BetLive.js.map
